import { useState, useEffect } from "react";

interface CountdownTimerProps {
  endsAt: number;
  size?: "sm" | "lg";
}

function pad(n: number) {
  return String(n).padStart(2, "0");
}

export default function CountdownTimer({ endsAt, size = "sm" }: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(Math.max(0, endsAt - Date.now()));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(Math.max(0, endsAt - Date.now()));
    }, 1000);
    return () => clearInterval(interval);
  }, [endsAt]);

  const hours = Math.floor(timeLeft / 3600000);
  const minutes = Math.floor((timeLeft % 3600000) / 60000);
  const seconds = Math.floor((timeLeft % 60000) / 1000);
  const expired = timeLeft === 0;

  if (size === "lg") {
    return (
      <div className="flex items-center gap-2">
        {[
          { val: pad(hours), label: "h" },
          { val: pad(minutes), label: "m" },
          { val: pad(seconds), label: "s" },
        ].map(({ val, label }, idx) => (
          <div key={label} className="flex items-center gap-2">
            <div className="flex flex-col items-center">
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl font-black text-2xl ${expired ? "bg-gray-200 text-gray-400" : "bg-gray-900 text-white"}`}>
                {val}
              </div>
              <span className="text-xs text-gray-400 mt-1 font-semibold">{label === "h" ? "horas" : label === "m" ? "min" : "seg"}</span>
            </div>
            {idx < 2 && <span className={`text-xl font-black mb-4 ${expired ? "text-gray-300" : "text-gray-700"}`}>:</span>}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-1 text-xs font-bold ${expired ? "text-gray-400" : "text-red-600"}`}>
      <i className="ri-time-line"></i>
      {expired ? "Expirado" : `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`}
    </div>
  );
}
